import React, { useContext, useState, useEffect, useCallback } from 'react'
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  Button,
  DatePicker,
  Input,
  Select,
  Radio,
  Divider,
  message,
} from 'antd'
import TransferData from 'core/component/TransferData'
import {
  getwindSubgroupEffective,
  windColMetaInfo,
  windReportGroup,
  windReportSubGroupTemplate,
  saveWindRptDataItem,
  saveWindRptSubgroup,
  generateAdhocReport,
} from 'api/pgads'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getApiTargetInfo,
  exportData,
  getValidYearRange,
  isValidYearRange,
} from 'core'
import {
  Content,
  CriteriaRow,
  FullHeightSizer,
  Title,
  Filler,
} from 'core/screen-util'
// import { rowHeaderRender, hasAccesPermits } from 'core/utils'
// import * as ScreenPermissions from 'core/EventActions'
// import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'
// import moment from 'moment'
import { getChangeDateSelectionProps } from './../reports/dm/changeDateSelection'
// import { setUnitGroupFilter } from 'analytics/actions'

const WindReport = ({ apiTargetInfo, ...props }) => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [colMetaInfoList, setColMetaInfoList] = useState([])
  const [selColMeta, setSelColMeta] = useState([])
  const [utilityList, setUtilityList] = useState([])
  const [selUtility, setSelUtility] = useState([])
  const [groupList, setGroupList] = useState([])
  const [selColMetaGoup, setSelColMetaGoup] = useState('custom')

  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [title, setTitle] = useState('Anonymous Report')
  const [dateSelectionType, setDateSelectionType] = useState(0)
  const [reportType, setReportType] = useState('xlsx')
  const [reportSubgroupList, setReportSubgroupList] = useState([])
  const [selSubgroup, setSelSubgroup] = useState('custom')
  const [newDataItemName, setNewDataItemName] = useState('')
  const [newSubgroupName, setNewSubgroupName] = useState('')

  const downloadReport = _ => {
    if (selUtility.length <= 0) {
      message.warning('Please Select Subgroup for generate Report')
      return
    }
    if (selColMeta.length <= 0) {
      message.warning('Please Select Dataitems to generate Report')
      return
    }
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return
    const data = {
      fromDate: selectedDateRangePicker[0]
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: selectedDateRangePicker[1].endOf('month').format('YYYY-MM-DD'),
      dataItems: selColMeta,
      // subGroups: utilityList.filter(s => selUtility.includes(s.subgroupId)),
      subGroups: selUtility,
      title,
    }

    setSpinning(true)
    generateAdhocReport(apiTargetInfo)(data, reportType).fork(setError, res => {
      setSpinning(false)
      res.rawResp
        .blob()
        .then(
          blob => exportData(blob, reportType, title + '.' + reportType),
          setError
        )
    })
  }

  const loadwindColMetaInfoList = useCallback(
    _ => {
      const red = ['SUBGROUP_NAME', 'YEAR', 'MONTH']
      windColMetaInfo(apiTargetInfo).fork(setError, data =>
        setColMetaInfoList(data.filter(f => !red.includes(f.ident)))
      )
    },
    [apiTargetInfo, setError]
  )

  const loadWindReportGroup = useCallback(
    _ => windReportGroup(apiTargetInfo).fork(setError, setGroupList),
    [apiTargetInfo, setError]
  )
  // const loadWindUtilitySelection = useCallback(
  //   _ => getWindUtilitySelection(apiTargetInfo).fork(setError, setUtilityList),
  //   [apiTargetInfo, setError]
  // )

  const loadWindUtilitySelection = useCallback(
    _ =>
      getwindSubgroupEffective(apiTargetInfo)(selectedDateRangePicker[0]).fork(
        setError,
        data => {
          setUtilityList(R.sortBy(R.prop('plantIdName'), data))
          setSelUtility([])
          setSelSubgroup('custom')
          setNewSubgroupName('')
        }
      ),

    [apiTargetInfo, selectedDateRangePicker, setError]
  )

  const loadWindReportSubgroupTemmplate = useCallback(
    _ =>
      windReportSubGroupTemplate(apiTargetInfo).fork(
        setError,
        setReportSubgroupList
      ),
    [apiTargetInfo, setError]
  )

  const reloadData = useCallback(
    _ => {
      // setSelColMetaGoup('custom')
      // setSelSubgroup('custom')
      // setSelColMeta([])
      // setSelUtility([])
      loadwindColMetaInfoList()
      loadWindReportGroup()
      loadWindUtilitySelection()
      loadWindReportSubgroupTemmplate()
    },
    [
      loadWindReportGroup,
      loadWindReportSubgroupTemmplate,
      loadWindUtilitySelection,
      loadwindColMetaInfoList,
    ]
  )

  useEffect(
    _ => {
      reloadData()
    },
    [
      apiTargetInfo,
      loadwindColMetaInfoList,
      // setError,
      loadWindReportGroup,
      loadWindUtilitySelection,
      loadWindReportSubgroupTemmplate,
      reloadData,
    ]
  )
  const onUpdateDataItemChnage = _ => {
    if (selColMeta.length === 0) {
      message.warning('Please Select Dataitem to save')
      return
    }
    if (newDataItemName.trim().length === 0) {
      message.warning("Please, put Dataitem's Group name")
      return
    }
    const save = selColMeta.map((n, i) => ({
      seq: i,
      templateName: newDataItemName.trim(),
      ident: n,
    }))
    saveWindRptDataItem(apiTargetInfo)(save).fork(setError, _ => {
      message.info('Data Item saved.')
      loadWindReportGroup()
    })
  }
  const onUpdateSubgroupChnage = _ => {
    if (selUtility.length === 0) {
      message.warning('Please Select Subgroup to save')
      return
    }

    if (newSubgroupName.trim().length === 0) {
      message.warning("Please, put Subgroup's Group name")
      return
    }
    const save = utilityList
      .filter(a => selUtility.includes(a.subgroupId))
      .map(({ subgroupId, utility }) => ({
        subgroupId,
        utility,
        groupname: newSubgroupName.trim(),
      }))
    saveWindRptSubgroup(apiTargetInfo)(save).fork(setError, _ => {
      message.info('Subgroup saved.')
      loadWindReportSubgroupTemmplate()
    })
  }

  const onSubGroupSelectionChange = val => {
    setSelSubgroup(val)
    setNewSubgroupName(val)
    if (val !== 'custom')
      setSelUtility(
        reportSubgroupList
          .filter(f => f.groupname === val)
          .map(s => s.subgroupId)
      )
  }

  const changeDateSelectionType = selType => {
    setDateSelectionType(selType)
    const val = getChangeDateSelectionProps(
      selType,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    setSelectedDateRagePicker([
      val.startDate.startOf('month'),
      val.endDate.endOf('month'),
    ])
  }

  const selectSelColMetaGoup = val => {
    setSelColMetaGoup(val)
    setNewDataItemName(val === 'custom' ? '' : val)
    if (val !== 'custom') {
      // colMetaInfoList.filter(f=>f.templateName)
      setSelColMeta(
        groupList.filter(f => f.templateName === val).map(i => i.ident)
      )
    }
  }

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '150px',
          }}
        >
          Wind Report
        </Title>
        <DatePicker.RangePicker
          allowClear={false}
          format="MMM-YYYY"
          mode={['month', 'month']}
          // mode="decade"
          value={selectedDateRangePicker}
          // placeholder={['Start month', 'End month']}
          // open={openPicker}
          onChange={dates => {
            setSelectedDateRagePicker(dates)
          }}
          onPanelChange={dates => {
            setSelectedDateRagePicker(dates)
          }}
          style={{ width: '200px' }}
        />
        <div style={{ display: 'grid' }}>
          <Select
            style={{ width: '200px', marginLeft: '10px' }}
            defaultValue={0}
            value={dateSelectionType}
            onChange={changeDateSelectionType}
          >
            <Select.Option value={0}>Custom Select</Select.Option>
            <Select.Option value={1}>Current Month</Select.Option>
            <Select.Option value={2}>Previous Month</Select.Option>
            <Select.Option value={3}>Current Year</Select.Option>
            <Select.Option value={4}>Year To Date</Select.Option>
            <Select.Option value={5}>Month To Date</Select.Option>
            <Select.Option value={6}>Previous Year</Select.Option>
            <Select.Option value={7}>Year To Month</Select.Option>
            <Select.Option value={8}>Year To Last Month</Select.Option>
            <Select.Option value={9}>Trailing Twelve Month</Select.Option>
            <Select.Option value={10}>Complete Year</Select.Option>
            <Select.Option value={11}>First Quarter</Select.Option>
            <Select.Option value={12}>Second Quarter</Select.Option>
            <Select.Option value={13}>Third Quarter</Select.Option>
            <Select.Option value={14}>Fourth Quarter</Select.Option>
          </Select>
        </div>

        <Radio.Group
          value={reportType}
          onChange={e => setReportType(e.target.value)}
          style={{ marginLeft: '10px' }}
        >
          <Radio value="xlsx">Excel</Radio>
          <Radio value="pdf">PDF</Radio>
        </Radio.Group>

        <div style={{ marginLeft: '20px' }}>Report Title : </div>
        <Input
          style={{ width: '200px', marginLeft: '5px' }}
          placeholder="Report Title"
          onChange={e => setTitle(e.target.value)}
          value={title}
        />
        <Button
          icon="database"
          loading={spinning}
          onClick={downloadReport}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Generate Report
        </Button>
        <Filler />
        <Button onClick={_ => reloadData()} type="dashed">
          Reload Data
        </Button>
      </CriteriaRow>
      <FullHeightSizer heightOffset={220}>
        {({ height }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'min-content 50px min-content',
                // gridTemplateRows: 'max-content',
                height: height - 20,
              }}
            >
              <fieldset style={{ height: height - 20 }}>
                <legend>
                  Select Data Item:
                  <Select
                    onChange={val => selectSelColMetaGoup(val)}
                    value={selColMetaGoup}
                    style={{ width: '150px', marginLeft: '10px' }}
                  >
                    <Select.Option value="custom">Custom</Select.Option>
                    {R.uniq(groupList.map(d => d.templateName)).map(k => (
                      <Select.Option key={k} value={k}>
                        {k}
                      </Select.Option>
                    ))}
                  </Select>
                  <Input
                    style={{ marginLeft: '10px', width: '150px' }}
                    disabled={selColMetaGoup !== 'custom'}
                    value={newDataItemName}
                    onChange={e => setNewDataItemName(e.target.value)}
                  />
                  <Button
                    style={{
                      marginLeft: '10px',
                      minWidth: '100px',
                      width: '100px',
                    }}
                    onClick={onUpdateDataItemChnage}
                  >
                    {R.uniq(groupList.map(d => d.templateName)).includes(
                      newDataItemName
                    )
                      ? 'Update'
                      : 'Create New'}
                  </Button>
                </legend>
                <TransferData
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '270px 30px 270px',
                    gridTemplateRows: '1fr',
                    gridColumnGap: '10px',
                    margin: '1px',
                    // maxHeight: height - 220,
                    // overflow: 'hide',
                  }}
                  listStyle={{
                    height: height - 150,
                    maxHeight: height - 150,
                    width: 'inherit',
                    margin: '5px',
                  }}
                  operationStyle={{
                    alignSelf: 'center',
                    justifySelf: 'center',
                  }}
                  dataSource={colMetaInfoList}
                  targetKeys={selColMeta}
                  setTargetKeys={targetKeys => setSelColMeta(targetKeys)}
                  isValidTransfer={_ => true}
                  titles={['Data Items', 'Selected']}
                  showSearch={false}
                  showSelectAll
                  isRightListSelectionStoreRequired
                  // selectedKeys={selectedKeys}
                  // disabled={!this.state.editable}
                  // onSelectChange={this.handleSelectChange}
                  // onScroll={this.handleScroll}
                  // disabled={disabled}
                  render={a => a.displayName}
                />
              </fieldset>
              <Divider
                type="vertical"
                style={{ height: height - 50, backgroundColor: 'black' }}
                dashed
              />
              <fieldset>
                <legend>
                  Select Subgroup:
                  <Select
                    style={{ width: '150px', marginLeft: '10px' }}
                    value={selSubgroup}
                    onChange={onSubGroupSelectionChange}
                  >
                    <Select.Option value="custom">Custom</Select.Option>
                    {R.sort(
                      R.toLower,
                      R.uniq(reportSubgroupList.map(s => s.groupname))
                    ).map(groupname => (
                      <Select.Option value={groupname} key={groupname}>
                        {groupname}
                      </Select.Option>
                    ))}
                  </Select>
                  <Input
                    style={{ marginLeft: '10px', width: '150px' }}
                    disabled={selColMetaGoup !== 'custom'}
                    value={newSubgroupName}
                    onChange={e => setNewSubgroupName(e.target.value)}
                  />
                  <Button
                    style={{
                      marginLeft: '10px',
                      minWidth: '100px',
                      width: '100px',
                    }}
                    onClick={onUpdateSubgroupChnage}
                  >
                    {R.uniq(reportSubgroupList.map(s => s.groupname)).includes(
                      newSubgroupName
                    )
                      ? 'Update'
                      : 'Create New'}
                  </Button>
                </legend>

                <TransferData
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '270px 20px 270px',
                    gridTemplateRows: '400px',
                    gridColumnGap: '10px',
                    margin: '1px',
                  }}
                  listStyle={{
                    height: height - 150,
                    width: 'inherit',
                    margin: '5px',
                  }}
                  operationStyle={{
                    alignSelf: 'center',
                    justifySelf: 'center',
                  }}
                  dataSource={utilityList || []}
                  targetKeys={selUtility}
                  setTargetKeys={targetKeys => setSelUtility(targetKeys)}
                  isValidTransfer={_ => true}
                  titles={['Subgroup', 'Selected']}
                  showSearch={false}
                  showSelectAll
                  isRightListSelectionStoreRequired
                  // selectedKeys={selectedKeys}
                  // disabled={!this.state.editable}
                  // onSelectChange={this.handleSelectChange}
                  // onScroll={this.handleScroll}
                  // disabled={disabled}
                  render={a => a.subgroupName}
                  rowKey={a => a.subgroupId}
                />
              </fieldset>
            </div>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  validYearRange: getValidYearRange(state),
})
export default connect(mapStateToProps)(WindReport)
